import { MutationTree } from 'vuex';
import {
  MultiSelectFieldOption,
  State,
} from '@/store/modules/log/logCommonState/log.store';
import {
  addWidgetDefulatData,
  executeSavedSearchDefaultData,
} from '@/components/Log/log.types';
import _ from 'lodash';
import { initialState } from '@/store/modules/log/logCommonState/log.store';

interface WidgetFieldInfoType {
  field: string;
  value: any;
}

const mutations: MutationTree<State> = {
  setQueryDataLoading(state: State, data: boolean) {
    state.queryDataLoading = data;
  },
  setQueryHeaders(state: State, data: any) {
    state.queryHeaders = data;
  },
  setReloadGrokTable(state: State, data: boolean) {
    state.reloadGrokTable = data;
  },
  setReloadSavedSearchTable(state: State, data: boolean) {
    state.reloadSavedSearchTable = data;
  },
  setSourceList(state: State, data: Array<object>) {
    state.sourceList = data;
  },
  setFreeSearchSources(state: State, data: Array<MultiSelectFieldOption>) {
    state.freeSearchSources = data;
  },
  setQueryEnableSavedSearchType(state: State, data: string) {
    state.queryEnableSavedSearchType = data;
  },
  setSavedSearchInfoFields(state: State, data: WidgetFieldInfoType) {
    state.addWidgetData.savedSearchInfo[data.field] = data.value;
  },
  setAddDashboardInfoFields(state: State, data: WidgetFieldInfoType) {
    state.addWidgetData.addDashboardInfo[data.field] = data.value;
  },
  setWidgetFormData(state: State, data: WidgetFieldInfoType) {
    state.addWidgetData.widgetFormData[data.field] = data.value;
  },
  resetAddWidgetData(state: State, data: string) {
    if (data === 'widgetFormData') {
      const formData = _.cloneDeep(addWidgetDefulatData[data]);
      formData.isCreateOrUpdateSavedSearch =
        !state.executeSavedSearch.isAddWidgetWithoutSavedSearch;
      state.addWidgetData.widgetFormData = formData;
    } else if (data === 'addDashboardInfo') {
      const dashData = _.cloneDeep(addWidgetDefulatData[data]);
      dashData.widgetType = state.addWidgetData.addDashboardInfo.widgetType;
      state.addWidgetData.addDashboardInfo = dashData;
    } else if (data === 'savedSearchInfo') {
      const addWidgetDataObj = _.cloneDeep(addWidgetDefulatData[data]);
      if (state.executeSavedSearch.isAddWidgetWithoutSavedSearch) {
        addWidgetDataObj.savedSearchName =
          state.addWidgetData.savedSearchInfo.savedSearchName;
      }
      state.addWidgetData.savedSearchInfo = addWidgetDataObj;
    }
  },
  resetExecuteSavedSearch(state: State) {
    state.executeSavedSearch = _.cloneDeep(executeSavedSearchDefaultData);
  },
  setExecuteSavedSearch(state: State, data: WidgetFieldInfoType) {
    state.executeSavedSearch[data.field] = data.value;
  },
  setIsADType(state: State, data: Boolean) {
    state.isADType = data;
  },
  setAnlyInfoFieldsList(state: State, data: Array<Object>) {
    state.anlyInfoFieldsList = data;
  },
  setLogInfoFieldsList(state: State, data: Array<Object>) {
    state.logInfoFieldsList = data;
  },
  setTagLoading(state: State, data: Boolean) {
    state.tagLoading = data;
  },
  setIsSearchListEmpty(state: State, data: Boolean) {
    state.isSearchListEmpty = data;
  },
  setSourceCurrentPage(state: State, data: Number) {
    state.sourceCurrentPage = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
